import { fetchAll, fetchFiltered, addBankAccount, show, edit } from '@/api/bankaccount'
import { t } from '@/lib/i18n'

const state = {
  all: [],
  isLoading: false,
  bankAccountById: null
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchById ({ dispatch, commit }, id) {
    try {
      const bankaccount = await show(id)
      commit('setBankAccountById', bankaccount)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchAll ({ dispatch, commit }) {
    try {
      const bankaccounts = await fetchAll()
      commit('setAll', bankaccounts)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchFiltered ({ dispatch, commit }, queriesParams) {
    try {
      const bankaccounts = await fetchFiltered(queriesParams)
      commit('setAll', bankaccounts)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async create ({ dispatch, commit }, data) {
    commit('setLoading', true)
    try {
      await addBankAccount(data)
      return true
    } catch (e) {
      dispatch('notify/error', {
        message: t(e.message) || e
      },
      { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  },

  async edit ({ dispatch, commit }, { id, data }) {
    commit('setLoading', true)
    try {
      await edit(id, data)
      return true
    } catch (e) {
      dispatch('notify/error', {
        message: t(e.message) || e
      },
      { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  }
}

const mutations = {
  cleanState (state) {
    state.all = []
    state.isLoading = false
    state.bankAccountById = null
  },

  setAll (state, bankaccounts) {
    state.all = bankaccounts
  },

  setBankAccountById (state, bankaccount) {
    state.bankAccountById = {
      id              : bankaccount.id,
      garageAccredited: bankaccount.garageAccredited,
      bank            : bankaccount.bank,
      agency          : bankaccount.agency,
      account         : bankaccount.account,
      pix             : bankaccount.pix || '',
      type            : bankaccount.type,
      name            : bankaccount.name,
      cpfCnpj         : bankaccount.cpfCnpj,
      isActive        : bankaccount.isActive
    }
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
